import { default as modalTemplate } from "./modal/template.jst";
import Button from "./controls/button";

import View from "backdraft-app/src/view";

import "vendor/bootstrap";

import _ from "underscore";
import $ from "jquery";

class Modal extends View {
  constructor(...args) {
    super(...args);

    if (!this.title) {
      throw new Error("You must provide a title to the modal");
    }
    if (!this.body) {
      throw new Error("You must provide a body to the modal");
    }

    _.defaults(this, {
      backdrop: true,
      fadeAnimation: false,
      buttons: []
    });
  }

  render() {
    this.$el.addClass("modal").html(modalTemplate({ size: this._sizeClass() }));
    this.$(".modal-title").html(_.result(this, "title"));

    const subtitle = _.result(this, "subtitle");
    if (_.isString(subtitle)) {
      this.$(".modal-subtitle").html(subtitle);
    } else {
      this.$(".modal-subtitle").hide();
    }

    const body = _.result(this, "body");
    if (_.isString(body)) {
      this.$(".modal-body-content").html(body);
    } else if (body instanceof View) {
      this.child("body", body);
      this.$(".modal-body-content").html(body.$el);
    } else {
      throw new Error("Result of body must be a string, or Backbone view");
    }

    const docs = _.result(this, "documentation");
    if (_.isString(docs)) {
      const docsLink = `<a href="${docs}">Link to documentation</a>`;
      this.$(".modal-documentation-link").html(docsLink);
    } else {
      this.$(".modal-documentation-link").hide();
    }

    this._buildButtons();

    if (this.fadeAnimation) {
      this.$el.addClass("fade");
    }
    const modalParams = { backdrop: this.backdrop, show: true };
    this.$el.modal(modalParams);
    const self = this;
    this.$el.on('hidden.bs.modal', () => {
      self.close();
    });

    return this;
  }

  close(...args) {
    this.$el.modal("hide");
    super.close(...args);
  }

  setError(message) {
    this.$(".modal-body-message").addClass('text-danger');
    this.$(".modal-body-message").html(message || "");
  }

  _sizeClass() {
    switch (this.size) {
    case "lg":
    case "large":
      return "modal-lg";
    case "sm":
    case "small":
      return "modal-sm";
    default:
      return "";
    }
  }

  _buildButtons() {
    const self = this;
    const buttons = _.map(_.result(this, "buttons"), function(config) {
      if (config.close) {
        config.click = () => {
          self.close();
          return false;
        };
      }
      config = _.omit(config, ["close"]);

      if (config.present && !config.present.call(this)) {
        return null;
      }

      const view = new Button(config).render();
      this.child(`button${view.cid}`, view);

      if (config.data) {
        this._addDataAttributes(config.data, view.$el);
      }

      return view;
    }, this);

    this.$(".modal-footer").append(_.pluck(buttons, "$el"));
    this.buttons = buttons;
  }

  _addDataAttributes(data, button) {
    const attributes = Object.keys(data);
    attributes.forEach(attr => {
      button.attr(`data-${attr}`, data[attr]);
    });
  }

  _displayServerErrors(response) {
    const errorsUl = $("<ul>");
    if (!_.isUndefined(response.responseJSON) && _.has(response.responseJSON, 'errors')) {
      const errors = response.responseJSON.errors;
      $.each(errors, i => {
        $("<li>").text(`${errors[i]}.`).appendTo(errorsUl);
      });
    } else {
      $("<li>").text("An unexpected error has occurred.").appendTo(errorsUl);
    }
    // TODO set class of error block? this._displayValidationMessages(errorsUl, 'text-danger');
    this.setError(errorsUl);
  }
}

export default Modal;
